import type { ThemeConfig } from 'antd';

/** UBUS Admin — Real-Time Operations dashboard (ui-ux-pro-max design system) */
export const adminTheme: ThemeConfig = {
  token: {
    colorPrimary: '#2563EB',
    colorSuccess: '#059669',
    colorWarning: '#D97706',
    colorError: '#DC2626',
    colorInfo: '#3B82F6',
    colorBgLayout: '#F8FAFC',
    colorBgContainer: '#FFFFFF',
    colorText: '#0F172A',
    colorTextSecondary: '#475569',
    colorTextTertiary: '#94A3B8',
    colorBorder: '#E2E8F0',
    colorBorderSecondary: '#F1F5F9',
    borderRadius: 10,
    borderRadiusLG: 12,
    fontFamily: "'Fira Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    fontFamilyCode: "'Fira Code', ui-monospace, monospace",
    boxShadow: '0 1px 3px rgba(15, 23, 42, 0.06)',
    boxShadowSecondary: '0 4px 12px rgba(15, 23, 42, 0.08)',
    controlHeight: 38,
    motionDurationMid: '0.2s',
  },
  components: {
    Layout: {
      siderBg: '#0F172A',
      headerBg: '#FFFFFF',
      bodyBg: '#F8FAFC',
    },
    Menu: {
      darkItemBg: 'transparent',
      darkSubMenuItemBg: 'transparent',
      darkItemSelectedBg: 'rgba(37, 99, 235, 0.18)',
      darkItemHoverBg: 'rgba(148, 163, 184, 0.12)',
      darkItemSelectedColor: '#FFFFFF',
      darkItemColor: 'rgba(226, 232, 240, 0.88)',
      itemBorderRadius: 8,
      itemMarginInline: 8,
      itemHeight: 44,
    },
    Card: {
      borderRadiusLG: 12,
      paddingLG: 20,
    },
    Table: {
      headerBg: '#F1F5F9',
      headerColor: '#334155',
      headerSplitColor: '#E2E8F0',
      rowHoverBg: '#EFF6FF',
      borderColor: '#E2E8F0',
      cellPaddingBlock: 10,
      cellPaddingInline: 14,
      fontSize: 14,
    },
    Button: {
      primaryShadow: '0 2px 6px rgba(37, 99, 235, 0.28)',
    },
  },
};

export const chartColors = {
  primary: '#2563EB',
  secondary: '#3B82F6',
  success: '#059669',
  warning: '#D97706',
  error: '#DC2626',
  info: '#06B6D4',
  purple: '#7C3AED',
  slate: '#64748B',
} as const;
